import React from 'react'
import { useLocation } from 'react-router-dom'
import Dropdown from '../../../partials/Dropdown'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'

function Filter(props) {

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('start_date', '')
        props.handleSearch('end_date', '')
        props.handleSearch('text', '')
    }

    return (
        <form className="filter-standard">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1" selected>
                        {trans('random.fromDate')}
                    </option>
                    <option value="2">
                        {trans('random.toDate')}
                    </option>
                    <option value="3">
                        {trans('random.search')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">
                <DateRange
                    startDate={props.filter.start_date}
                    endDate={props.filter.end_date}
                    onStartDateChange={(date) => {
                        props.handleSearch('start_date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('end_date', date)
                    }}
                />
            </div>

            <div className="col" data-id="3">
                <input
                    type="search"
                    name="text"
                    onKeyUp={handleSearch}
                    onChange={handleSearch}
                    value={props.filter.text}
                    placeholder={trans('labels.search')}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>

        </form>
    )
}

export default React.memo(Filter, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})